// @flow
import * as React from 'react';
import Box from 'sail/Box';
import {Text, Title} from 'sail/Text';

import './StepSection.scss';

type StepSectionProps = {|
  number: string,
  title: string,
  toggle: boolean,
  children: React.Element<any>,
|};

export const StepSection = ({
  number,
  title,
  toggle,
  children,
}: StepSectionProps) => {
  if (toggle && children) {
    return (
      <Box className="StepSection--extra" padding={{top: 48, horizontal: 32}}>
        {children}
      </Box>
    );
  }

  return (
    <Box
      className="StepSection"
      flex={{alignItems: 'center'}}
      margin={{horizontal: 32, top: 32}}
      padding={{bottom: 20}}
    >
      <Text
        className="StepSection--number"
        color="white"
        lineHeight={16}
        size={11}
        weight="bold"
      >
        {number}
      </Text>
      <Title className="StepSection--title" color="dark">
        {title}
      </Title>
    </Box>
  );
};
